import { useContext } from 'react'
import { ThemeContext } from '../contexts/themeStore'

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) throw new Error('useTheme doit être utilisé dans ThemeProvider')
  return context
}
